// Plugin
import Swiper from 'swiper/bundle';
import { Navbar, Modal } from 'bootstrap';
import WOW from 'wow.js';

new WOW().init();

// ViewportHeight
const updateViewportHeight = () => {
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
};
updateViewportHeight();

//Page Hash
let hash = window.location.hash;
if(hash){
    setTimeout(() => {
        window.scrollTo({
            top: document.querySelector(hash).offsetTop - document.querySelector('.navbar').offsetHeight,
            behavior: 'smooth'
        })
    }, 1000);
}

// Slider
let swiper = new Swiper(".about-swiper, .menu-swiper, .location-swiper", {
    autoplay: {
        delay: 3000,
    },
    slidesPerView: 1,
    spaceBetween: 0,
    speed: 1000,
    loop: true,
    pagination: {
        el: ".swiper-pagination",
        clickable: true
    }
});

// Dining Slider
const dining_swiper = new Swiper(".dining-swiper", {
    slidesPerView: 1,
    spaceBetween: 8,
    breakpoints: {
        1200: {
            slidesPerView: 4,
            spaceBetween: 8
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 8
        },
        576: {
            slidesPerView: 2,
            spaceBetween: 8
        },
    },
    speed: 1000,
    rewind: true,
    navigation: {
        nextEl: '.dining-swiper-control-right',
        prevEl: '.dining-swiper-control-left',
    },
});

// Video Changer
let brand_video = document.querySelector('.brand-video').querySelector('iframe');
let all_video_tabs = document.querySelector('.video-tabs').querySelectorAll('.tab');
all_video_tabs.forEach(tab => {
    tab.addEventListener('click', (e) => {
        all_video_tabs.forEach(tab => {tab.classList.remove('active')})
        tab.classList.add('active');
        e.preventDefault();
        let videoUrl = "https://www.youtube.com/embed/" + tab.dataset.id + "?autoplay=1&mute=0&enablejsapi=1";
        brand_video.setAttribute('src', videoUrl);
    })
});

// News Modal
document.addEventListener('DOMContentLoaded', () => {
    let newsModal = document.querySelector('#newsModal');
    if(newsModal) {
        window.scrollTo(0, 0)
        $('#newsModal').modal('show');
    }
})